<div class="container-fluid text-center">
    <img id="header-logo" src="logo-blue.svg" alt="Marlin Connect" height="28" />
    <div class="row my-4">
        <div class="col-12">
            <div class="ion-text-center">
                <h3 class="font-normal text-3xl">{{ "Welcome" }}, {{ applicationContextStore.displayName() }}</h3>
            </div>
        </div>
    </div>
    @if (!isLoaded()) {
        <div class="row">
            <div class="col-12">
                <div class="mx-10">
                    <div class="spinner-grow text-primary loading-spinner" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
